/* @flow */
/** @jsx h */
import { h } from 'preact';
import cssStyles from './index.css';
import { RootStore } from '../../js/stores/root.store';

type Props = {
  /** Unique id */
  id?: string;
  /** Icon wrapper styles (positioning) */
  style?: h.JSX.CSSProperties;
  /** Position on the creative */
  position?: string;
  /** Container style */
  containerStyle?: h.JSX.CSSProperties;
  isVertical?: boolean;
};

/**
 * Use `BrandItem` to display a brand name and a logo
 */
export default function BrandItem({
  style,
  position,
  containerStyle,
  isVertical
}: Props) {
  const brandItem = RootStore.getInstance().configStore.config.brandItem;
  const name = !isVertical ? brandItem?.name : undefined;

  return (
    <div className={cssStyles.brandItem} style={containerStyle}>
      <div
        style={style}
        className={
          position === 'left'
            ? cssStyles.brandItemContainer
            : cssStyles.brandItemContainerReverse
        }
      >
        {brandItem?.logo && (
          <img
            className={cssStyles.brandItemLogo}
            src={brandItem.logo}
            alt="logo"
          />
        )}
        {name && <div className={cssStyles.brandItemName}>{name}</div>}
      </div>
    </div>
  );
}
